import { useEffect } from "react"
import { imageUrlOptimizer } from "../utils/imageUrlOptimizer"

/**
 * NOTE: Optimizing images, videos, and iframes inside the article for better performance
 * @param {string} selectors - The selectors to which the click event is attached
 * @param {Array} dependencies - The dependencies to which the click event is attached
 * @returns {void}
 */
const useRichTextMediaOptimizer = (selectors, dependencies = []) => {
  useEffect(() => {
    const articleElement = document.querySelectorAll(selectors)

    if (articleElement) {
      articleElement.forEach(element => {
        const mediaElements = element.querySelectorAll("img, video, iframe")

        mediaElements.forEach(element => {
          const tagName = element.tagName.toLowerCase()

          if (tagName === "img") {
            element.setAttribute("decoding", "async")
            element.setAttribute("loading", "lazy")
            element.src = imageUrlOptimizer(element.src)
            return
          } else if (tagName === "video") {
            element.setAttribute("preload", "metadata")
            return
          } else if (tagName === "iframe") {
            element.setAttribute("loading", "lazy")
            return
          }
        })
      })
    }
  }, [...dependencies])
}

export default useRichTextMediaOptimizer
